import request from '@/utils/request'

export function fetchProduct (query) {
  return request({
    url: '/vipProduct',
    method: 'get',
    params: query
  })
}
